<template>
	<div style="background-color: #EFEFEF;">
		
		<span class="go-index" @click="pageTo()">返回</span>

		<!-- 空白展位 -->
		<div style="padding: .25rem 0;"></div>

		<div class="order-div">
			<div style="height: 0.8rem;">
				<span style="font-size: .5rem;color: #000000;">收货地址</span>
			</div>
			<div style="height: 0.8rem;">
				<span style="font-size: .4rem;color: #000000;">接口未返回</span>
			</div>
			<div>
				<span style="font-size: .4rem;color: #000000;">接口未返回</span>
			</div>
		</div>

		<!-- 空白展位 -->
		<div class="" style="padding: .25rem 0;"></div>

		<div class="order-div" style="color: #101010;">
			<div>
				<span style="font-size: .5rem;color: #000000;">商品清单</span>
			</div>

			<div class="goods-list" v-for="goods of goodsInfo" :key="goods.goods_id">
				<img :src="goods.goods_image" style="display: block; width: 2rem;float: left;border-radius: 0.2rem;" />
				<div style="padding-left: 1rem;width: 8rem; font-size: 0.5rem;height: 2rem;float: left;">
					<span style="">{{goods.goods_name}}</span>
				</div>
				<div style="margin-left: 0.5rem; width: 3rem; font-size: 0.5rem;height: 2rem;float: right;text-align: right;">
					<span>￥{{goods.goods_price}}</span><br>
					<span>x{{goods.goods_num}}</span>
				</div>
			</div>

			<div style="font-size: 0.5rem; padding-top: 0.5rem;">
				<span style="width: 2rem;">价格明细 </span>
				<span style="float: right;">折扣 ￥0.00</span>
			</div>
			<div style="font-size: 0.5rem; padding-top: 0.5rem; text-align: right;">
				<span>共{{count.num}}件商品 总计</span>
				<span style="color: #ff9d8f;">￥{{count.sum}}</span>
			</div>

		</div>

		<!-- 空白展位 -->
		<div class="" style="padding: .25rem 0;"></div>

		<div class="order-div" style="font-size: 0.5rem;height: 1.5rem;line-height: 1.5rem;">
			<span>买家留言</span>
			<span style="margin-left: 2rem;color: #101010;">50字以内(选填)</span>
		</div>

		<!-- 空白展位 -->
		<div class="" style="padding: .25rem 0;"></div>

		<div class="order-div" style="font-size: 0.5rem;">
			<div style="padding: 0.3rem 0;">
				<span>商品小计</span>
				<span style="float: right;">￥{{count.sum}}</span>
			</div>
			<div class="cut-line">
				<span>运费</span>
				<span style="float: right;">￥0.00</span>
			</div>
			<div class="cut-line">
				<span>实付款</span>
				<span style="float: right;">￥{{count.sum}}</span>
			</div>
		</div>

		<!-- 空白展位 -->
		<div class="" style="padding: .25rem 0;"></div>

		<div class="order-div" style="font-size: 0.5rem;">

			<div style="padding: 0.3rem 0;">
				<span>订单编号</span>
				<span style="float: right;">2025101308241133</span>
			</div>
			<div class="cut-line" v-if="orderInfo.order_time != 0">
				<span>创建时间</span>
				<span style="float: right;">{{orderInfo.order_time}}</span>
			</div>
			<div class="cut-line" v-if="orderInfo.time_pay != 0">
				<span>付款时间</span>
				<span style="float: right;">{{orderInfo.time_pay}}</span>
			</div>
			<div class="cut-line" v-if="orderInfo.time_deliver!= 0">
				<span>发货时间</span>
				<span style="float: right;">{{orderInfo.time_deliver}}</span>
			</div>
			<div class="cut-line" v-if="orderInfo.time_receive != 0">
				<span>收货时间</span>
				<span style="float: right;">{{orderInfo.time_receive}}</span>
			</div>
			<div class="cut-line" v-if="orderInfo.time_finish != 0">
				<span>完成时间</span>
				<span style="float: right;">{{orderInfo.time_finish}}</span>
			</div>
			<div class="cut-line" v-if="orderInfo.time_close != 0">
				<span>关闭时间</span>
				<span style="float: right;">{{orderInfo.time_close}}</span>
			</div>

		</div>

		<br />
		<br />
		<br />

		<div class='order-bottom' v-if="orderInfo.order_status == 1">
			<div class='order-payment' @click="toPayment(orderInfo.order_id, orderInfo.order_fee)">立即支付</div>
			<div class='order-paytext'>实付款: <span style="color: #ff9d8f;">￥{{count.sum}}</span></div>
		</div>

		<!-- 组件使用 -->
		<syalert ref="syalert_id" />

	</div>
</template>
<style>
	.cut-line {
		margin: 0.3rem 0;
		padding-top: 0.3rem;
		border-top: 1px solid #EFEFEF;
	}

	.order-div {
		width: 90%;

		background-color: #FFFFFF;
		padding: .5rem 0;

		padding-left: .5rem;
		padding-right: .5rem;

		margin: 0 auto;

		border-radius: .5rem;
	}

	.goods-list
	{
		height: 2rem;
		margin-top: .5rem;
	}


	.order-bottom {
		width: 100%;
		height: 3rem;

		position: fixed;
		bottom: 0px;

		/* border: 1px solid blue; */
		background-color: #ffffff;
	}

	.order-paytext {
		float: right;

		margin: 0.5rem 0;

		font-size: .7rem;
		color: black;
		text-align: center;

		height: 2rem;
		width: 6rem;

		line-height: 2rem;
	}

	.order-payment {
		float: right;

		margin: 0.5rem 0.5rem;

		font-size: .7rem;
		color: white;
		text-align: center;

		height: 2rem;
		width: 6rem;
		border-radius: 2rem;

		line-height: 2rem;

		background-color: #d9001b;
	}
</style>
<script>
	// 组件引入
	import sy from "@/sy";

	import syalert from '@/components/syalert.vue';
	// import foot from '@/components/foot.vue';

	export default {
		name: 'submit',
		components: {
			syalert,
		},
		data() {
			return {
				goodsInfo: [],
				orderInfo: [],
				oid: 0,
				count:
				{
					num: 0,
					sum: 0,
				},
			}
		},
		methods:
		{
			pageTo: function(page) {
				if (page !== undefined) {
					this.$router.push(page);
				} else {
					this.$router.go(-1);
				}
			},
			// 支付订单
			toPayment(oid, fee)
			{
				this.$router.push('/order/payment?oid=' + oid + '&fee=' + fee );
			},
			getOrder: function() {
				// ----- ----- 实例重命名
				let $_this = this;
				sy.http.get({
					url: this.$root.API + 'Order/Get',
					data: {
						'oid': this.oid,
					},
					success: function(res) {
						if (res.state === '0') {
							return $_this.$refs.syalert_id.syalert(res.msg);
						}

						// console.log(res.data);
						$_this.orderInfo = res.data;
						$_this.goodsInfo = res.data.order_item;

						let num = 0;
						let sum = 0;
						for (let x of res.data.order_item) {
							num++;
							sum += parseFloat(x.goods_price) * x.goods_num;
						}
						$_this.count.num = num;
						$_this.count.sum = sum.toFixed(2);
					}
				});
			},

		},
		created() {
			this.oid = this.$router.currentRoute.query.oid;
			console.log(this.oid);

			// 实际哪个过来对我们有什么影响吗 方便判断而已
			this.getOrder();

		},
	}
</script>